/**
 * @generated SignedSource<<95b3a1bd1cdfd61164fcb93e46945fb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type authAuthenticatedUserQuery$variables = {};
export type authAuthenticatedUserQuery$data = {
  readonly GetAuthenticatedUser: {
    readonly code: string;
    readonly name: string;
  };
};
export type authAuthenticatedUserQuery = {
  response: authAuthenticatedUserQuery$data;
  variables: authAuthenticatedUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "GetAuthenticatedUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "authAuthenticatedUserQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authAuthenticatedUserQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ebd9bc0826c2c678927941325993c548",
    "id": null,
    "metadata": {},
    "name": "authAuthenticatedUserQuery",
    "operationKind": "query",
    "text": "query authAuthenticatedUserQuery {\n  GetAuthenticatedUser {\n    code\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc7e6f5b940c64d30ea64dacf594a7e6";

export default node;
